import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-zahlkond-list-view',
  imports: [],
  templateUrl: './zahlkond.list-view.html',
  styleUrls: ['./zahlkond.list-view.css'],
})
export class ZahlkondListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
